module.exports = __webpack_public_path__ + "img/transparency.3c1b36ae.png";